// extracted by mini-css-extract-plugin
export default {"container":"PlanejamentoBody_container__Rc6TU","square":"PlanejamentoBody_square__Lt2Jl"};